export const ADD_FIRSTNAME = 'ADD_FIRSTNAME';
export const ADD_LASTNAME = 'ADD_LASTNAME';
export const ADD_ID = 'ADD_ID';
export const ADD_ROL = 'ADD_ROL';



type UserActionType = typeof ADD_FIRSTNAME | typeof ADD_LASTNAME | typeof ADD_ID|typeof ADD_ROL;

export interface Module {
  key: number;
  id: string;
  keyModule: string;
  link: string;
  label: string;
  icon: string;
  description: string;
  createdAt: string;
}

export interface UserDataType {
  key: number;
  fullname: string;
  rol: string;
  rol_name: string;
  terms: string;
  id: string;
  type: string;
  identification: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  position: string;
  area: string;
  birthday: string | null;
  password: string;
  acceptTermsConditions: boolean;
  status: string;
  createdAt: string;
  updatedAt: string;
  msOrganizationOrganizationId: string;
  msOrganizationOrganizationRuc: string;
}









export interface UserAction {
    type: UserActionType;
    payload: any;
  }
  export interface UserLoginState {
    password: string,
    username: string
  }
  

  export interface UserState {
    id?: string,
    organizationid: string,
    type: string,
    identificaton:string,
    firstname: string,
    lastname: string,
    email: string,   
    rol:string,
    phone: string,
    position:string,
    area:string,
    birthday: string,
    status: string
  }

  export interface RegisterUser {
    id:string,
    organizationId:string,
    msOrganizationOrganizationRuc:string;
    msOrganizationOrganizationId: string;
    terms:string;
    type: string,
    identification:string,
    firstname: string,
    lastname: string,
    email: string,
    position: string,
    area: string,
    phone: string,
    birthday: string,
    rol :string,
    rolname:string,
    createdAt:string
  }

  export interface Rol {
    id:string,
    name:string,
    type: string,
  }

  export interface UserClient extends RegisterUser{
    
    fullname: string,
    organization: string
  }